import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=38d1803b&scoped=true"
import script from "./CreateGame.vue?vue&type=script&lang=ts"
export * from "./CreateGame.vue?vue&type=script&lang=ts"
import style0 from "./CreateGame.vue?vue&type=style&index=0&id=38d1803b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d1803b",
  null
  
)

export default component.exports